import { render, staticRenderFns } from "./DropdownBoxSection.vue?vue&type=template&id=91bb3068&scoped=true"
import script from "./DropdownBoxSection.vue?vue&type=script&lang=js"
export * from "./DropdownBoxSection.vue?vue&type=script&lang=js"
import style0 from "./DropdownBoxSection.vue?vue&type=style&index=0&id=91bb3068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bb3068",
  null
  
)

export default component.exports